import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Archived = forwardRef<SVGSVGElement | null, IconFilledProps>(function Archived({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M9.75 13.25C9.47386 13.25 9.25 13.4739 9.25 13.75V14.25C9.25 14.5261 9.47386 14.75 9.75 14.75H14.25C14.5261 14.75 14.75 14.5261 14.75 14.25V13.75C14.75 13.4739 14.5261 13.25 14.25 13.25H9.75Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.25 5.00021C2.24997 3.48126 3.48131 2.25 5.00021 2.25H18.9999C20.5186 2.25 21.7499 3.48097 21.7499 4.99983V8.00017C21.7499 9.25908 20.904 10.3202 19.7496 10.6466V20C19.7496 20.9665 18.9661 21.75 17.9996 21.75H5.99962C5.03321 21.75 4.24971 20.9666 4.24964 20.0002C4.24945 17.764 4.24951 15.5278 4.24957 13.2917L4.24961 10.6463C3.09554 10.3197 2.24997 9.25854 2.25 7.99981V5.00021ZM18.9999 9.25H5.00019C4.30968 9.25 3.74999 8.69029 3.75 7.99984L3.75 5.00018C3.74998 4.30972 4.30969 3.75 5.00021 3.75H18.9999C19.6903 3.75 20.2499 4.30956 20.2499 4.99983V8.00017C20.2499 8.69044 19.6903 9.25 18.9999 9.25ZM18.2496 10.75H5.74961L5.74957 13.3051C5.74951 15.5368 5.74945 17.7684 5.74964 20.0001C5.74965 20.1381 5.86155 20.25 5.99962 20.25H17.9996C18.1377 20.25 18.2496 20.1381 18.2496 20V10.75Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M22 4C22 2.89543 21.1045 2.00001 20 2L4.00019 2C2.89544 2 1.99995 2.89571 2.00002 4.00045L2 7.49718C1.99996 8.60285 2.8971 9.49873 4.00276 9.49717L20.0028 9.47467C21.1062 9.47312 22 8.57814 22 7.47467V4Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.49977 12C4.49977 11.4477 4.94749 11 5.49977 11H18.4997C19.052 11 19.4997 11.4477 19.4997 12L19.4997 20C19.4997 21.1046 18.6043 22 17.4997 22H6.49975C5.39518 22 4.49974 21.1046 4.49975 20L4.49977 12ZM14.0697 15.75C14.3459 15.75 14.5697 15.5261 14.5697 15.25V14.75C14.5697 14.4738 14.3459 14.25 14.0697 14.25H9.92971C9.65357 14.25 9.42971 14.4738 9.42971 14.75V15.25C9.42971 15.5261 9.65357 15.75 9.92971 15.75H14.0697Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'archived-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Archived;
